import GatewaysView from './GatewaysView.vue'

export default GatewaysView;
